import { useState } from "react";
import { Grid, Typography } from "@mui/material";
import { Box } from "@mui/system";
import _ from "lodash";
import {
  ApproverHistoryDisplay,
  checkKnownDateOrString,
  useApproverHistoryList,
  useSampleRequestPageLink,
} from "../";
import { useEffect } from "react";

export function ItemListTableItemDetails({ cellValues }) {
  const [itemData, setItemData] = useState();
  const [sampleData, setSampleData] = useState();
  const sampleRequestPageLink = useSampleRequestPageLink(
    cellValues.sampleRequestID
  );
  const { approverHistoryList, isApproverHistoryListLoading } =
    useApproverHistoryList(cellValues.sampleRequestID);

  useEffect(() => {
    let {
      sampleRequestID,
      department,
      email,
      purpose,
      endUserLocation,
      executiveChefEmail,
      HODDepartment,
      needByDate,
      leadTime,
      requestDate,
      dateModified,
      organization,
      ...dataRest
    } = cellValues;

    setSampleData({
      // sampleRequestID,
      department,
      email,
      purpose,
      endUserLocation,
      executiveChefEmail,
      HODDepartment,
      needByDate,
      leadTime,
      requestDate,
      dateModified,
      organization,
    });

    setItemData(dataRest);
  }, [cellValues]);
  return (
    <Box>
      <Grid
        container
        sx={{
          display: "flex",
          alignItems: "left",
          justifyContent: "left",
          flexDirection: "column",
        }}
      >
        <Grid item xs={6}>
          <Typography variant="h6" component="h5" gutterBottom>
            <b> Request Details</b>
          </Typography>
          <Grid container style={{ fontSize: "14px", marginBottom: "5px" }}>
            <Grid item xs={12} sm={5}>
              <span>Sample Request ID:</span>
            </Grid>
            <Grid item xs={12} sm={7}>
              <a href={sampleRequestPageLink} target="_blank" rel="noreferrer">
                {cellValues.sampleRequestID}
              </a>
            </Grid>
          </Grid>
          {sampleData &&
            Object.keys(sampleData).map((oneKey, i) => {
              return (
                <Grid
                  container
                  key={i}
                  style={{ fontSize: "14px", marginBottom: "5px" }}
                >
                  <Grid
                    item
                    xs={12}
                    sm={5}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <span>{_.startCase(Object.keys(sampleData)[i]) + ":"}</span>
                    <ApproverHistoryDisplay
                      item={Object.keys(sampleData)[i]}
                      data={approverHistoryList}
                      isLoading={isApproverHistoryListLoading}
                    />
                  </Grid>
                  <Grid item xs={12} sm={7}>
                    <span>
                      {checkKnownDateOrString(oneKey, sampleData[oneKey])}
                    </span>
                  </Grid>
                </Grid>
              );
            })}
        </Grid>
        <Grid item xs={6}>
          <Typography variant="h6" component="h5" gutterBottom>
            <b> Item Details</b>
          </Typography>
          {itemData &&
            Object.keys(itemData).map((oneKey, i) => {
              return (
                <Grid
                  container
                  key={i}
                  style={{ fontSize: "14px", marginBottom: "5px" }}
                >
                  <Grid item xs={12} sm={5}>
                    <span>{_.startCase(Object.keys(itemData)[i]) + ":"}</span>
                  </Grid>
                  <Grid item xs={12} sm={7}>
                    <span>
                      {checkKnownDateOrString(oneKey, itemData[oneKey])}
                    </span>
                  </Grid>
                </Grid>
              );
            })}
        </Grid>
      </Grid>
    </Box>
  );
}
